import React from 'react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/audit';
export function Bonuses() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-70" data-mp="av34oprykyzk">
      <div className="mx-auto w-full max-w-5xl" data-id="element-71" data-mp="aujww1w0vqz9">
        <SectionHeading eyebrow="🎁 Only with today’s offer" title="Get 5 professional bonuses free" subtitle="Five additional resources included at no extra cost when you get the Complex Rehab Case Audit™ today." data-id="element-72" data-mp="ftmtqz1umqw5" />

        <div className="mt-10 space-y-6" data-id="element-73" data-mp="5xbga5qivv04">
          {bonuses.map(b => <article key={b.label} className="overflow-hidden rounded-3xl bg-cream-100 ring-1 ring-navy-900/10" data-id="element-74" data-mp="3o2ws5h0s23mp">
              <img src={b.image} alt={`${b.title} — ${b.subtitle}`} className="w-full bg-white" loading="lazy" data-id="element-75" data-mp="1mai21uo2xsv7" />
              <div className="p-5 sm:p-7" data-id="element-76" data-mp="3ieg9h9e6kh3h">
                <span className="inline-block rounded-full bg-navy-900 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-gold-300" data-id="element-77" data-mp="3idemc6jw445e">
                  {b.label}
                </span>
                <h3 className="mt-3 font-display text-xl font-bold leading-tight text-navy-900 sm:text-2xl" data-id="element-78" data-mp="3r5gihsmxey9v">
                  {b.title}
                </h3>
                <p className="mt-1.5 text-[15px] font-semibold text-clay" data-id="element-79" data-mp="2zfanq61mpnhu">
                  {b.subtitle}
                </p>
                <p className="mt-3 text-[14px] leading-relaxed text-navy-700/80 sm:text-[15px]" data-id="element-80" data-mp="2uh97dsvl82a2">
                  {b.description}
                </p>
                <p className="mt-4 inline-flex items-center gap-2 rounded-xl bg-gold-500/15 px-3.5 py-2 text-[11px] font-extrabold uppercase tracking-[0.1em] text-navy-900 ring-1 ring-gold-500/40" data-id="element-81" data-mp="38e5wnpw25bou">
                  <span className="line-through opacity-50" data-id="element-82" data-mp="ns47u21lbu64">
                    Value: {b.value}
                  </span>
                  <span className="text-clay" data-id="element-83" data-mp="3cj6hyfhvvupw">Free today</span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-84" data-mp="3hgg3vl62do8z">
          <CTAButton label="Get all 5 bonuses free" subLabel="Included with today’s $27 offer" data-id="element-85" data-mp="3hju8z1644bk4" />
        </div>
      </div>
    </section>;
}